import PropTypes from 'prop-types';

export const yotpoInfoPT = PropTypes.arrayOf(PropTypes.exact({
  id: PropTypes.string,
  name: PropTypes.string,
}));

